module.exports = __webpack_public_path__ + "static/media/LK_Settings.8c151471.svg";